import { I18nComponente } from "@/types/gerais"

export const OSelecionarProjetosGrupoi18n: I18nComponente = {
  "pt-BR": {
    nome: "nome",
    codigo: "código",
    usuariosResponsaveis: "usuários responsáveis",
    limpar: "Limpar",
    aplicar: "Aplicar",
    pesquisarPorNomeDoProjeto: "pesquisar por nome do projeto",
    pesquisarPorCodigoDoProjeto: "pesquisar por código do projeto",
    pesquisarPorUsuarioResponsavel: "pesquisar por usuário responsável",
    erroAoBuscarProjetos: "Erro ao buscar projetos",
    ocorreuUmErroAoBuscarOsProjetos: "Ocorreu um erro ao buscar os projetos, tente novamente mais tarde."
  },
  "es-CO": {
    nome: "nombre",
    codigo: "código",
    usuariosResponsaveis: "usuarios responsables",
    limpar: "Borrar",
    aplicar: "Aplicar",
    pesquisarPorNomeDoProjeto: "buscar por nombre del proyecto",
    pesquisarPorCodigoDoProjeto: "buscar por código del proyecto",
    pesquisarPorUsuarioResponsavel: "buscar por usuario responsable",
    erroAoBuscarProjetos: "Error al buscar proyectos",
    ocorreuUmErroAoBuscarOsProjetos: "Ocurrió un error al buscar los proyectos, inténtelo de nuevo más tarde."
  }
}
